import { IDriver } from "dataModels/contract";
import {
    FormMode,
    DATE_FORMAT,
    EntityType,
    getDriverFileInputConfig,
    IFileInputConfig,
    DsLayout,
} from "shared/constants";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-grid-system";
import moment from "moment";
import SimpleTable from "components/SimpleTable";
import { v4 as uuid } from "uuid";
import _ from "lodash";
import "views/contractView/styles/contractDataStyles.css"; //to be replaced with its own one
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";
import { Output } from "@ds/ds-snam/react";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";

interface IDriverFormReview {
    formData: IDriver;
}
const DriverInfo: React.FC<IDriverFormReview> = (props): JSX.Element => {
    const { t } = useTranslation(["contract"]);

    return (
        <>
            <Row style={{ marginBottom: "12px" }}>
                <Col>
                    <div className="box">
                        <div className="boxTitle">
                            {/*Informazioni anagrafiche*/}
                            {t("drivers.driverForm.sections.review.title.0")}
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.0"
                                    )}
                                    outputText={props.formData.firstName}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.2"
                                    )}
                                    outputText={props.formData.birthPlace}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.10"
                                    )}
                                    outputText={props.formData.documentType}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.0')}
                            </p>
                            <p className="boxFieldData">{props.formData.firstName}</p>

                            <p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.2')}
                            </p>
                            <p className="boxFieldData">{props.formData.birthPlace}</p>
                            <p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.10')}
                            </p>
                            <p className="boxFieldData">{props.formData.documentType}</p>*/}
                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.1"
                                    )}
                                    outputText={props.formData.lastName}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.3"
                                    )}
                                    outputText={parseDateForDS(
                                        moment
                                            .unix(props.formData.birthDate)
                                            .format(DATE_FORMAT),
                                        IParseDateFormatType.DATE_FORMAT1
                                    )}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.11"
                                    )}
                                    outputText={props.formData.documentNumber}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.1')}
                            </p>
                            <p className="boxFieldData">{props.formData.lastName}</p>
                            <p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.3')}
                            </p>
                            <p className="boxFieldData">{props.formData.birthDate}</p>
                            <p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.11')}
                            </p>
                            <p className="boxFieldData">{props.formData.documentNumber}</p>*/}
                            </div>
                            {(props.formData.status.toString()==="2"||props.formData.status.toString()==="3"||props.formData.status.toString()==="4"||props.formData.status.toString()==="7"||props.formData.cardCode!=="") && <div
                                className="boxContentColumn"
                                style={{ height: "83%" }}
                            >
                                <Output
                                    outputTitle={"Code Card"} //code card
                                    outputText={props.formData.cardCode===''?'-':props.formData.cardCode}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                            </div>}
                        </div>
                    </div>
                </Col>
                <Col>
                    <div className="box">
                        <div className="boxTitle">
                            {/*Indirizzo*/}
                            {t("drivers.driverForm.sections.review.title.1")}
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.4"
                                    )}
                                    outputText={props.formData.address}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.6"
                                    )}
                                    outputText={props.formData.city}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.8"
                                    )}
                                    outputText={props.formData.province}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.4')}
                            </p>
                            <p className="boxFieldData">{props.formData.address}</p>
                            <p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.6')}
                            </p>
                            <p className="boxFieldData">{props.formData.city}</p>
                            <p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.8')}
                            </p>
                            <p className="boxFieldData">{props.formData.province}</p>*/}
                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.5"
                                    )}
                                    outputText={props.formData.streetNumber}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.7"
                                    )}
                                    outputText={props.formData.postalCode}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                <Output
                                    outputTitle={t(
                                        "drivers.driverForm.sections.dataInput.fields.9"
                                    )}
                                    outputText={props.formData.state}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.5')}
                            </p>
                            <p className="boxFieldData">{props.formData.streetNumber}</p>
                            <p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.7')}
                            </p>
                            <p className="boxFieldData">{props.formData.postalCode}</p>
                            <p className="boxFieldLabel">
                                
                                {t('drivers.driverForm.sections.dataInput.fields.9')}
                            </p>
                            <p className="boxFieldData">{props.formData.state}</p>*/}
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};
export default DriverInfo;
